import React from 'react';
import AOS from 'aos';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanugageContext';
import { offerTranslations } from '../../translations/offer';

AOS.init({
    useClassNames: true,
    initClassName: false,
    animatedClassName: 'animated',
    easing: 'ease-in-out-cubic',
    duration: 600
});

const offerMeta = [
    {
        offerClass: "offer",
        figClass: "dubrovnik-offer-img",
        link: "http://www.tzdubrovnik.hr/lang/en/index.html",
        secondLink: null,
        btnLink: "/dubrovnik"
    },
    {
        offerClass: "offer second-offer",
        figClass: "elaphite-offer-img",
        offerOrder: "offer-order",
        link: "http://www.tzdubrovnik.hr/lang/en/get/okolica_dubrovnika/62179/otok_lopud.html",
        secondLink: "http://www.tzdubrovnik.hr/lang/en/get/okolica_dubrovnika/62186/otok_sipan.html",
        btnLink: "/elaphiti"
    }
];

const Offer = () => {
    const { lang } = useLanguage();
    const tr = offerTranslations[lang];

    const renderedOffers = offerMeta.map((meta, index) => {
        const offer = tr.offers[index];
        return (
            <div className={meta.offerClass} key={index}>
                <div className={meta.offerOrder}>
                    <figure className={meta.figClass} />
                </div>
                <div className="description animated" data-aos="fade-top">
                    <div>
                        <h2>{offer.decsTitle}</h2>
                        <h4>{offer.descLead}</h4>
                        <span />
                        <p>
                            {offer.firstP}
                            <a href={meta.link}>{offer.linkP}</a>
                            {offer.and}
                            {meta.secondLink && (
                                <a href={meta.secondLink}>{offer.secondLinkP}</a>
                            )}
                            {offer.secondP}
                        </p>
                        <div className="button">
                            <Link to={meta.btnLink}>
                                <button>{tr.seeMore}</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    });

    return (
        <div>
            <div>
                <div className="offers">
                    {renderedOffers}
                </div>
            </div>
        </div>
    );
};

export default Offer;